import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Bot, CalendarDays, Cog, LayoutDashboard, Package, TrendingUp, UserPlus, Wallet, } from 'lucide-react';
var features = [
    {
        title: 'Reduce Operational Costs',
        icon: Wallet,
        copy: 'Save monthly on your budget, by cutting the cost of hiring additional employees, office space, and time used in your clinic.',
    },
    {
        title: 'Serve More Patients',
        icon: UserPlus,
        copy: 'Use the enhanced patient process and increased productivity, to ultimately increase the number of patients served each day.',
    },
    {
        title: 'Medical Machines',
        icon: Cog,
        copy: 'Record medical machines, their usages, and make packages that provide the price list for each entity in your clinic.',
    },
    {
        title: 'Automation',
        icon: Bot,
        copy: 'Apply our intelligent automation tools are easy to use and personalize communication between your teams and patients.',
    },
    {
        title: 'Comprehensive Dashboard',
        icon: LayoutDashboard,
        copy: 'Enjoy intuitive dashboard, task lists, and customizable multi-resource calendar.',
    },
    {
        title: 'Flexible Calendar',
        icon: CalendarDays,
        copy: 'Save time and customize your schedule so your front office can easily manage important patient communications.',
    },
    {
        title: 'Inventory Management',
        icon: Package,
        copy: 'Supply your company through the Purchases module. You can manage the suppliers, items, use returns, and detailed audits.',
    },
    {
        title: 'Maximize Productivity',
        icon: TrendingUp,
        copy: "Support your staff's entire practice workflow including managing patients, uploading documents, and sending secure messages.",
    },
];
var Features = function () {
    return (_jsxs("section", { className: "lnd-section", id: "features", children: [_jsxs("header", { className: "lnd-section__head", children: [_jsx("h2", { children: "Product Features" }), _jsx("p", { children: "Everything you need in one platform" })] }), _jsx("div", { className: "lnd-features", children: features.map(function (feature) {
                    var Icon = feature.icon;
                    return (_jsxs("article", { className: "lnd-feature", children: [_jsxs("div", { children: [_jsx("h3", { children: feature.title }), _jsx("span", { children: _jsx(Icon, { size: 18 }) })] }), _jsx("p", { children: feature.copy })] }, feature.title));
                }) })] }));
};
export default Features;
